export var consultationReasons = [{
  title: 'Alcoolisme/Toxicomanie',
  children: ['Alcoolisme/Toxicomanie']
}, {
  title: 'Alimentation intuitive',
  children: ['Alimentaion intuitive']
}, {
  title: 'Alimentation saine et équilibrée ',
  children: ['Techniques culinaires/Menus santé']
}, {
  title: 'Allaitement',
  children: ['Consultation en lactation (allaitement)']
}, {
  title: 'Allergies/Intolérances alimentaires',
  children: ['Allergies/Intolérances alimentaires']
}, {
  title: 'Anémie',
  children: ['Hématologie (anémies, maladies du sang)']
}, {
  title: 'Animation/Éducation/Conférence',
  children: ['Animation/Éducation/Conférence']
}, {
  title: 'Arthrite/Arthrose (rhumatologie) ',
  children: ['Rhumatologie']
}, {
  title: 'Calculs ou lithiases urinaires (pierres aux reins)',
  children: ['Néphrologie']
}, {
  title: 'Cancer/Oncologie',
  children: ['Oncologie']
}, {
  title: 'Chirurgie bariatrique',
  children: ['Chirurgie bariatrique']
}, {
  title: 'Chirurgie cardiaque',
  children: ['Chirurgie cardiaque']
}, {
  title: 'Chirurgie gastro-intestinale',
  children: ['Chirurgie gastro-intestinale']
}, {
  title: 'Chirurgie ORL (tête et cou)',
  children: ['Chirurgie ORL (tête et cou)']
}, {
  title: 'Cholestérol/Lipides sanguins/Triglycérides',
  children: ['Endocrinologie (cholestérol, diabète, ostéoporose, syndrome métabolique, thyroïde)', 'Maladies cardiovasculaires', 'Maladies métaboliques héréditaires', 'Syndrome métabolique']
}, {
  title: 'Consultation en lactation (allaitement)',
  children: ['Consultation en lactation (allaitement)']
}, {
  title: "Dénutrition/Malnutrition (perte d'appétit, perte de poids involontaire)",
  children: ["Dénutrition/malnutrition (perte d'appétit, perte de poids involontaire)"]
}, {
  title: 'Dermatologie',
  children: ['Dermatologie']
}, {
  title: 'Diabète',
  children: ['Endocrinologie (cholestérol, diabète, ostéoporose, syndrome métabolique, thyroïde)', 'Syndrome métabolique']
}, {
  title: 'Diversification alimentaire menée par l\'enfant (DME)',
  children: ['Diversification alimentaire menée par l\'enfant (DME)']
}, {
  title: 'Dysphagie (difficulté à avaler)',
  children: ['Dysphagie (difficulté à avaler)']
}, {
  title: 'Endocrinologie (ostéoporose, syndrome métabolique, thyroïde, etc.)',
  children: ['Endocrinologie (cholestérol, diabète, ostéoporose, syndrome métabolique, thyroïde)']
}, {
  title: 'Étiquetage nutritionnel',
  children: ['Étiquetage nutritionnel']
}, {
  title: 'Fibrose kystique',
  children: ['Fibrose kystique', 'Maladies respiratoires']
}, {
  title: 'Gastro-entérologie',
  children: ['Gastro-entérologie (côlon, diverticulite, constipation, diarrhée, estomac, foie, intestin, œsophage, pancréas/pancréatite, vésicule biliaire)']
}, {
  title: 'Greffes/Transplantation ',
  children: ['Greffes']
}, {
  title: 'Grossesse/Périnatalité (diabète gestationnel, nausée, vomissements, etc.)',
  children: ['Grossesse à risque', 'Grossesse/périnatalité']
}, {
  title: 'Gynécologie ',
  children: ['Gynécologie']
}, {
  title: 'Hématologie (anémies, maladies du sang)',
  children: ['Hématologie (anémies, maladies du sang)']
}, {
  title: 'Hypertension, AVC',
  children: ['Maladies cardiovasculaires']
}, {
  title: 'Lupus',
  children: ['Immunologie (lupus, VIH/sida…)', 'Rhumatologie']
}, {
  title: 'Maladie coeliaque',
  children: ['Maladie coeliaque']
}, {
  title: 'Maladie de Crohn',
  children: ['Gastro-entérologie (côlon, diverticulite, constipation, diarrhée, estomac, foie, intestin, œsophage, pancréas/pancréatite, vésicule biliaire)']
}, {
  title: 'Maladie de Parkinson',
  children: ['Maladies neurologiques']
}, {
  title: 'Maladies cardiovasculaires',
  children: ['Maladies cardiovasculaires', 'Syndrome métabolique']
}, {
  title: 'Maladies dégénératives',
  children: ['Maladies dégénératives']
}, {
  title: 'Maladies métaboliques héréditaires',
  children: ['Maladies métaboliques héréditaires']
}, {
  title: 'Maladies neurologiques',
  children: ['Maladies neurologiques']
}, {
  title: 'Maladies rénales/Néphrologie',
  children: ['Néphrologie']
}, {
  title: 'Maladies respiratoires',
  children: ['Fibrose kystique', 'Maladies respiratoires']
}, {
  title: 'Médias/Communications',
  children: ['Conception audiovisuelle/Radio/Télé/Médias']
}, {
  title: 'Ménopause',
  children: ['Gynécologie']
}, {
  title: 'Néonatalogie (nouveaux-nés, bébés)',
  children: ['Néonatalogie (soins spécialisés du nouveau-né)', 'Néonatologie']
}, {
  title: 'Nutraceutiques/Aliments fonctionnels',
  children: ['Nutraceutiques/Aliments fonctionnels']
}, {
  title: 'Nutrigénomique/Nutrigénétique',
  children: ['Nutrigénomique/Nutrigénétique']
}, {
  title: 'Nutrition sportive',
  children: ['Nutrition sportive']
}, {
  title: 'Obésité',
  children: ['Obésité ']
}, {
  title: 'Oncologie',
  children: ['Oncologie ']
}, {
  title: 'Ostéoporose',
  children: ['Endocrinologie (cholestérol, diabète, ostéoporose, syndrome métabolique, thyroïde)', 'Rhumatologie']
}, {
  title: 'Perte de poids',
  children: ['Obésité', 'Techniques culinaires/Menus santé']
}, {
  title: 'Perte de poids involontaire (dénutrition, malnutrition)',
  children: ["Dénutrition/malnutrition (perte d'appétit, perte de poids involontaire)"]
}, {
  title: 'Plaies',
  children: ['Plaies']
}, {
  title: 'Problèmes digestifs',
  children: ['Gastro-entérologie (côlon, diverticulite, constipation, diarrhée, estomac, foie, intestin, œsophage, pancréas/pancréatite, vésicule biliaire)']
}, {
  title: 'Réadaptation physique',
  children: ['Déficience physique', 'Réadaptation physique', 'Réadaptation']
}, {
  title: 'Réadaptation fonctionnelle',
  children: ['Réadaptation fonctionnelle', 'Réadaptation']
}, {
  title: 'Réadaptation intellectuelle',
  children: ['Réadaptation intellectuelle', 'Réadaptation']
}, {
  title: 'Réadaptation motrice',
  children: ['Réadaptation motrice', 'Réadaptation']
}, {
  title: 'Rhumatologie (arthrite, lupus, sclérodermie, vasculites, ostéoporose , etc.)',
  children: ['Rhumatologie']
}, {
  title: 'Santé dentaire',
  children: ['Santé dentaire']
}, {
  title: 'Santé mentale',
  children: ['Santé mentale (incluant TDAH/autisme)']
}, {
  title: 'Sélectivité alimentaire (TCARE)',
  children: ['Sélectivité alimentaire (TCARE)']
}, {
  title: 'Soins palliatifs et de fin de vie',
  children: ['Soins palliatifs']
}, {
  title: 'Techniques culinaires/Menus santé',
  children: ['Techniques culinaires/Menus santé']
}, {
  title: 'Thyroïde',
  children: ['Endocrinologie (cholestérol, diabète, ostéoporose, syndrome métabolique, thyroïde)']
}, {
  title: "Trouble de déficit d'attention (TDA/H)",
  children: ['Santé mentale (incluant TDAH/autisme)']
}, {
  title: 'Troubles de conduites alimentaires (anorexie, boulimie, hyperphagie, orthorexie)',
  children: ['Trouble du comportement alimentaire (anorexie, boulimie...)']
}, {
  title: "Troubles du spectre de l'autisme (TSA)",
  children: ['Santé mentale (incluant TDAH/autisme)']
}, {
  title: 'Végétarisme/Végétalisme/Véganisme',
  children: ['Végétarisme/Végétalisme/Véganisme']
}, {
  title: 'VIH/SIDA',
  children: ['Immunologie (lupus, VIH/sida...)']
}];